/* eslint-disable @typescript-eslint/no-inferrable-types */
import { ColumnTransformerFloat } from 'src/modules/database/shared/column-transformer-float';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity, Unique } from 'typeorm';

@Entity()
@Unique(["pupilId", "year", "domain"])
export class FinalGrade extends SmBaseEntity {
    @Column({default: 0})
    pupilId: number = 0;

    @Column({default: 0})
    year: number = 0;

    @Column({default: ""})
    domain: string = "";

    @Column({ type: 'decimal', precision: 9, scale: 3, nullable: true, transformer: new ColumnTransformerFloat()})
    writtenGrade: number;

    @Column({ type: 'decimal', precision: 9, scale: 3, nullable: true, transformer: new ColumnTransformerFloat()})
    oralGrade: number;

    @Column({ type: 'decimal', precision: 9, scale: 3, nullable: true, transformer: new ColumnTransformerFloat()})
    finalGrade: number;

    @Column({default: false})
    floor: boolean = false;

    @Column({default: ""})
    note: string = "";

}